module.exports = __webpack_public_path__ + "static/media/IconDispute.036a37be.svg";